import { cn } from "@/lib/utils";

interface OddPillProps {
  odds: number | null;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'gold' | 'muted';
  isEstimated?: boolean;
  className?: string;
}

export function OddPill({ 
  odds, 
  size = 'md',
  variant = 'gold',
  isEstimated = false,
  className 
}: OddPillProps) {
  if (odds === null || odds === undefined) return null;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5'
  };

  const variantClasses = {
    gold: 'bg-[hsl(var(--sg7-gold))] text-[hsl(var(--sg7-surface-1))]',
    muted: 'bg-[hsl(var(--sg7-surface-3))] text-[hsl(var(--sg7-text))]'
  };

  // Use ≈ prefix for estimated odds, @ for real odds
  const prefix = isEstimated ? '≈' : '@';

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center",
        "font-black tabular-nums tracking-tight",
        "rounded-md",
        "shadow-sm",
        // Subtle gradient shine
        "bg-gradient-to-b from-white/10 to-transparent",
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
      style={{
        textShadow: variant === 'gold' ? '0 1px 0 rgba(0,0,0,0.2)' : 'none'
      }}
    >
      {prefix}{odds.toFixed(2)}
    </span>
  );
}
